import { withRouter, Redirect, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { getMediaQueryState } from 'redux/selectors';
import { Typography } from '@mui/material';
import {
	CheckCircle,
	MailOutline,
	Inventory2Outlined,
} from '@mui/icons-material';
import { NavBack, PrimaryButton, SecondaryButton } from 'components';
import clsx from 'clsx';
import styles from '../child.module.css';

const elephantMask = {
	WebkitMaskImage: 'url(/assets/ella-elephant.svg)',
	maskImage: 'url(/assets/ella-elephant.svg)',
};

export function ExitedCare(props) {
	const history = useHistory();
	const { isMd } = useSelector(getMediaQueryState);

	const {
		location: { search },
	} = props;

	const { success, elephant = 'below' } = queryString.parse(search) || {};

	// TEMP: preview elephant styles via ?elephant=below|badge|header|watermark
	const Elephant = ({ className }) => (
		<span
			role='img'
			aria-label='Ella Elephant'
			className={clsx(styles.exitedCareElephant, className)}
			style={elephantMask}
		/>
	);

	const topIcon = {
		badge: (
			<div className={styles.exitedCareBadge}>
				<Elephant className={styles.exitedCareBadgeElephant} />
				<CheckCircle className={styles.exitedCareBadgeCheck} />
			</div>
		),
		header: (
			<div className={styles.exitedCareHeaderElephant}>
				<Elephant className={styles.exitedCareHeaderElephantImage} />
				<CheckCircle className={styles.exitedCareBadgeCheck} />
			</div>
		),
	}[elephant] || <CheckCircle className={styles.exitedCareIcon} />;

	const handleBack = () => {
		history.push('/lifebooks');
	};

	const handleArchive = () => {
		history.push('/archive/');
	};

	return success === 'true' ? (
		<div className={styles.exitedCareContainer}>
			{isMd && (
				<div className={styles.goBack}>
					<NavBack onClick={handleBack} />
				</div>
			)}
			<div className={styles.exitedCareCard}>
				{elephant === 'watermark' && (
					<Elephant className={styles.exitedCareWatermark} />
				)}
				{topIcon}
				<Typography variant='h5' className={styles.exitedCareTitle}>
					Exiting Care Successful
				</Typography>
				<Typography className={styles.exitedCareSubtitle}>
					This child has been exited from care.
				</Typography>
				<div className={styles.exitedCareSections}>
					<div className={styles.exitedCareSection}>
						<MailOutline className={styles.exitedCareSectionIcon} />
						<Typography>
							Please check your email for further instructions on handling the
							child account. An email has also been sent to the state/county
							social worker listed on file for this child.
						</Typography>
					</div>
					<div className={styles.exitedCareSection}>
						<Inventory2Outlined className={styles.exitedCareSectionIcon} />
						<Typography>
							Further records of this child can be found in the archive
							section. Please allow a few moments for the archive to compile.
						</Typography>
					</div>
				</div>
				<div className={styles.exitedCareButtons}>
					<SecondaryButton onClick={handleArchive} style={{ marginLeft: 0 }}>
						View Archive
					</SecondaryButton>
					<PrimaryButton onClick={handleBack} style={{ marginLeft: 0 }}>
						Back to Lifebooks
					</PrimaryButton>
				</div>
			</div>
			{elephant === 'below' && (
				<Elephant className={styles.exitedCareImage} />
			)}
		</div>
	) : (
		<Redirect to='/children/' />
	);
}

export default withRouter(ExitedCare);
